export default (EDITOR => {
    EDITOR.plugins.add('key-binder', {
        requires : ['richcombo'],
        init : innerEditor => {
            const keys = [
                [ '{{Confirmation_Number}}', 'Confirmation Number', 'Confirmation Number' ],
                [ '{{Arrival_Date}}', 'Arrival Date', 'Arrival Date' ],
                [ '{{Departure_Date}}', 'Departure Date', 'Departure Date' ],
                [ '{{Nights}}', 'Nights', 'Nights' ],
                [ '{{Room_Type_Description}}', 'Room Type Description', 'Room Type Description' ],
                [ '{{Number_Of_Rooms}}', 'Number Of Rooms', 'Number Of Rooms' ],
                [ '{{Adult_Count}}', 'Adult Count', 'Adult Count' ],
                [ '{{Child_Count}}', 'Child Count', 'Child Count' ],
                [ '{{Total_Person}}', 'Total Person', 'Total Person' ],
                [ '{{Total_Amount_With_Currency}}', 'Total Amount With Currency', 'Total Amount With Currency' ],

            ];

            innerEditor.ui.addRichCombo('key-binder', {
                label       : 'Fields',
                title       : 'Fields',
                toolbar     : 'key-binder',
                className   : 'cke_format',
                multiSelect : false,
                panel: {
                    css         : [ innerEditor.config.contentsCss, EDITOR.skin.getPath('editor') ]
                },
                init: function() {
                    this.startGroup('Insert data field');
                    for (let i in keys) {
                        this.add(keys[i][0], keys[i][1], keys[i][2]);
                    }
                },
                onClick: function(value) {
                    innerEditor.focus();
                    innerEditor.fire('saveSnapshot');
                    innerEditor.insertHtml(value);
                    innerEditor.fire('saveSnapshot');
                }
            });
        }
    });
})